import { authLoginRequest, authLogoutRequest, authRegisterRequest, authResetPasswordRequest } from '@store/slices/auth/authSlice.js';
import { takeLatest } from 'redux-saga/effects';

import { loginRequestSaga } from './login';
import { logoutRequestSaga } from './logout';
import { registerRequestSaga } from './register';
import { resetPasswordRequestSaga } from './resetPassword';

export function* loginRequestWatcher() {
  yield takeLatest(authLoginRequest, loginRequestSaga);
}

export function* logoutWatcher() {
  yield takeLatest(authLogoutRequest, logoutRequestSaga);
}

export function* registerWatcher() {
  yield takeLatest(authRegisterRequest, registerRequestSaga);
}
export function* resetPasswordWatcher() {
  yield takeLatest(authResetPasswordRequest, resetPasswordRequestSaga);
}
